import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FeatureAccessGuard from './FeatureAccessGuard';
import { FEATURE_NAMES } from '../../apis/featureLimits';
import ExceptionalForm from '../ExceptionalForm';
import { FloatingUsageIndicator } from './FeatureUsageIndicator';
import { validateProfileComplete } from '../../utils/profileValidation';

// Wrapper component that adds feature limiting to KnackMoments
// Blocks free users but allows paid users with usage limits
const KnackMomentsWithLimits = () => {
  const navigate = useNavigate();

  // Check profile completion on component mount
  useEffect(() => {
    if (!validateProfileComplete({ showAlert: true, navigate })) {
      // Profile is incomplete - alert already shown by validateProfileComplete
      // If user clicks "Go to Profile Hub", they will be redirected
    }
  }, [navigate]);

  return (
    <FeatureAccessGuard 
      featureName={FEATURE_NAMES.KNACK_MOMENTS}
      customMessage="KnackMoments are not available for free users. Please upgrade to access this premium feature."
    >
      <FloatingUsageIndicator 
        featureName={FEATURE_NAMES.KNACK_MOMENTS} 
        position="top-right" 
      />
      <ExceptionalForm />
    </FeatureAccessGuard>
  );
};

export default KnackMomentsWithLimits;
